import styled from '@emotion/styled';
import { ItemResponse } from '@models/item';
import { ReactNode } from 'react';

import useOptionGuard from './hooks/useOptionGuard';

interface Props {
    children: ReactNode;
    item: ItemResponse;
}

function OptionSelectionGuard({ item, children }:Props) {
    const { preventMinOptionCount, isPrevent } = useOptionGuard(item);
    return (
        <div onClick={preventMinOptionCount}>
            <Guard isPrevent={isPrevent}>
                {children}
            </Guard>
        </div>
    );
}

const Guard = styled.div<{isPrevent: boolean}>`
    pointer-events: ${(props) => (props.isPrevent ? 'none' : 'auto')};
`;

export default OptionSelectionGuard;
